function navigation(submenu) {
	const parentMenuItem = submenu.parentNode;
	const siblingMenus = window._farlo.helpers.getSiblings(submenu);

	const openMenu = (item, menu) => {
		item.classList.add('site-navigation__menu-item--active');
		menu.classList.add('site-navigation__sub-menu--active');
		menu.setAttribute('aria-hidden', 'false');
		item.setAttribute('aria-expanded', 'true');
	};

	const closeMenu = (item, menu) => {
		item.classList.remove('site-navigation__menu-item--active');
		menu.classList.remove('site-navigation__sub-menu--active');
		//menu.setAttribute('aria-hidden', 'true');
		item.setAttribute('aria-expanded', 'false');
	};

	const closeAllMenus = () => {
		siblingMenus.forEach((sibling) => {
			const siblingItem = sibling.children[ 0 ];
			const siblingMenu = sibling.children[ 1 ];
			if (siblingItem && siblingItem.classList.contains('site-navigation__menu-item--active')) {
				closeMenu(siblingItem, siblingMenu);
			}
		});
	};
	// siblingMenus.forEach(_menu => {
	// 	_menu.
	// })

	const handleKeyDown = (e) => {
		const doc = parentMenuItem.ownerDocument;
		const activeElement = doc.activeElement;
		const items = Array.from(parentMenuItem.querySelectorAll('.site-navigation__menu-link'));
		const currentIndex = items.indexOf(activeElement);
		let newIndex = -1;

		switch (e.key) {
			case 'ArrowDown':
				e.preventDefault();
				newIndex = (currentIndex + 1) % items.length;
				items[ newIndex ].focus();
				break;
			case 'ArrowUp':
				e.preventDefault();
				newIndex = (currentIndex - 1 + items.length) % items.length;
				items[ newIndex ].focus();
				break;
			case 'ArrowRight':
				if (submenu.classList.contains('site-navigation__sub-menu--active')) {
					e.preventDefault();
					const firstSubmenuItem = submenu.querySelector('.site-navigation__menu-link');
					if (firstSubmenuItem) {
						firstSubmenuItem.focus();
					}
				}
				break;
			case 'ArrowLeft':
			case 'Escape':
				e.preventDefault();
				closeMenu(parentMenuItem, submenu);
				parentMenuItem.querySelector('.site-navigation__menu-link').focus();
				break;
			case 'Enter':
			case ' ':
				e.preventDefault();
				if (submenu.classList.contains('site-navigation__sub-menu--active')) {
					closeMenu(parentMenuItem, submenu);
				} else {
					openMenu(parentMenuItem, submenu);
					closeAllMenus();
				}
				break;
		}
	};

	if (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
		siblingMenus[ 0 ].addEventListener('click', (e) => {
			// if (!e.target.classList.contains('site-navigation__menu-item--active')) {
			// 	e.preventDefault();
			// 	openMenu(e.currentTarget, submenu);
			// 	closeAllMenus();
			// } else {
			// 	return true;
			// }
		});
	} else {
		parentMenuItem.addEventListener('mouseover', () => {
			closeAllMenus();
			openMenu(parentMenuItem, submenu);
		});

		parentMenuItem.addEventListener('mouseout', () => {
			closeMenu(parentMenuItem, submenu);
		});

		parentMenuItem.addEventListener('keydown', handleKeyDown);
	}

	submenu.setAttribute('aria-hidden', 'true');
	parentMenuItem.setAttribute('aria-haspopup', 'true');
	parentMenuItem.setAttribute('aria-expanded', 'false');

	// Add tabindex to all menu links for focus management
	const menuLinks = submenu.querySelectorAll('.site-navigation__menu-link');
	menuLinks.forEach((link) => {
		link.setAttribute('tabindex', '0');
	});

}
function navicon() {
    const header = document.querySelector('.site-header');
    const dropdown = document.querySelector('.site-navigation__dropdown');
    const logo = document.querySelector('.site-logo');
    const navRight = document.querySelector('.site-navigation__right');
    const navIcon = document.querySelector('.site-navigation__navicon');

    document.querySelectorAll('.site-navigation__navicon').forEach((naviconElement) => {
        naviconElement.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            // Toggle the active state of the navicon and dropdown
            naviconElement.classList.toggle('site-navigation__navicon--active');
            dropdown.classList.toggle('site-navigation__dropdown--active');
            document.body.classList.remove('site-navigation--search');
            document.body.classList.toggle('site-navigation--open');

            // Check if dropdown is open
            if (dropdown.classList.contains('site-navigation__dropdown--active')) {
                header.classList.add('site-header--menu-open'); // Add class when the menu is open
            } else {
                header.classList.remove('site-header--menu-open'); // Remove the class when the menu is closed
                logo.style.opacity = '1';
                navRight.style.opacity = '1';
                navIcon.style.opacity = '1'; 
            }
        });
    });

    // Listen for the scroll event inside the dropdown
    dropdown.addEventListener('scroll', () => {
        if (dropdown.scrollTop > 0) {
            // As soon as we start scrolling, move the elements off the screen
            logo.style.opacity = '0'; // Adjust this value to control the movement
            navRight.style.opacity = '0'; // Adjust this value to control the movement
            navIcon.style.opacity = '0'; // Adjust this value to control the movement
        } else {
            // If we scroll back to the top, bring the elements back into view
            logo.style.opacity = '1';
            navRight.style.opacity = '1';
            navIcon.style.opacity = '1';
        }
    });
}





function searchIcon() {
	document.querySelector(".site-navigation__search").addEventListener("click", (e) => {
		e.preventDefault();
		e.stopPropagation();
		document.body.classList.remove('site-navigation--open');
		document.body.classList.toggle('site-navigation--search');
	});
	document.querySelector(".site-navigation__search-area-close").addEventListener("click", (e) => {
		document.body.classList.remove('site-navigation--search');

	});
}

export { navigation, navicon, searchIcon };